// @flow
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';

declare var $: any;

export default class Form1View extends JQueryView {
  constructor() {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.render();
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field1') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    if (!$(event.target).closest('.date-field1').length) {
      $('.date-field1').removeClass('focus');

      if ($('.date-field1').val().length === 0) {
        $('.date-field1').removeClass('form-control-active');
      }
    }
  }

  render() {
    this.initDateRangePicker(this.$el);
  }
}
